import { routeTo } from 'dux/router/actions';
import { Dispatch } from 'app/types/redux';
export { default as Errors } from './errors';

/******************
 * Initial state
 */
const initialState = {
    errorList: [],
    nextErrorId: 0,
};

/******************
 * Non-async action types
 */
const ERROR_ADD = 'ERROR_ADD';
const ERROR_DISMISS = 'ERROR_DISMISS';
const ERROR_DISMISS_ALL = 'ERROR_DISMISS_ALL';
const ERROR_DISMISS_BY_TYPE = 'ERROR_DISMISS_BY_TYPE';

/******************
 * Reducer
 */
export default function errorReducer( state = initialState, action: any ) {
    switch ( action.type ) {
        case ERROR_ADD:
            return {
                ...state,
                nextErrorId: state.nextErrorId + 1,
                errorList: [ ...state.errorList, { ...action.error, ...{ errorType: action.errorType, errorId: state.nextErrorId + 1 } } ],
            };
        case ERROR_DISMISS:
            return {
                ...state,
                errorList: state.errorList.filter( (err: any) => {
                    return err.errorId !== action.errorId;
                } ),
            };
        case ERROR_DISMISS_ALL:
            return {
                ...state,
                errorList: [],
            };
        case ERROR_DISMISS_BY_TYPE:
            return {
                ...state,
                errorList: state.errorList.filter( (err: any) => err.errorType !== action.errorType ),
            };
        default:
            return state;
    }
}

/******************
 * Action creators
 */
export function addError( error: any, errorType: any ) {
    return ( dispatch: Dispatch ) => {
        dispatch( {
            type: ERROR_ADD,
            error,
            errorType,
        } );
        switch ( error.name ) {
            case 'InvalidClientError':
            case 'ConfigAppFetchError':
            case 'InvalidClientSaltError':
            case 'NoClientKeyError':
            case 'InvalidSpoofedDomainError':
                return dispatch( routeTo( '/error' ) );
            default:
                break;
        }
    };
}
export function dismissError( errorOrErrorId: any ) {
    return {
        type: ERROR_DISMISS,
        errorId: typeof ( errorOrErrorId ) === 'number' ? errorOrErrorId : errorOrErrorId.errorId,
    };
}
export function dismissAllErrors() {
    return {
        type: ERROR_DISMISS_ALL,
    };
}
export function dismissErrorsByType( errorType: any ) {
    return {
        type: ERROR_DISMISS_BY_TYPE,
        errorType,
    };
}
